import {
  type LocalUserEntity
} from '@/core/infrastructure/schemas/users/core/LocalUserSchema.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory.ts'
import { LocalUser } from '@/core/domain/users/LocalUser.ts'
import type IProfileRepository from '@/core/domain/profile/IProfileRepository.ts'
import { resolveView } from '@/core/infrastructure/services/ViewResolver.ts'
import { LocalUserFactory } from '@/core/infrastructure/mappers/users/LocalUserFactory.ts'

export class ProfileRepository implements IProfileRepository {
  async fetchMe(): Promise<LocalUser> {
    const response = await apiService.get<LocalUserEntity>('profile/me')
    return LocalUserFactory.createLocalUser(response.data, resolveView(response.getHeader('accept-view')))
  }
}